import { LoadingOutlined } from '@ant-design/icons';
import ArrowDownCrmIcon from '@icons/ArrowDownCrmIcon';
import { cx } from '@utils/cx';
import { Select as BasSelect, SelectProps } from 'antd';

const Select = (props: SelectProps) => (
  <BasSelect
    {...props}
    className={cx('customSelect w-full', props.className)}
    dropdownClassName={cx('rounded-b-[6px]', props.dropdownClassName)}
    suffixIcon={props?.loading ? <LoadingOutlined /> : <ArrowDownCrmIcon strokeColor="#a2a2a2" />}
    onChange={(value, options) => {
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      props.onChange && props.onChange(value || null, options);
    }}
  />
);

Select.Option = BasSelect.Option;
export default Select;
